/***********************************
** 折叠面板
** 格式
<div class="collapse-loop">
    <div class="item active">
        <div class="item-hd">折叠面板标题</div>
        <div class="item-md">折叠面板内容</div>
    </div>
    <div class="item">
        <div class="item-hd">折叠面板标题</div>
        <div class="item-md">折叠面板内容</div>
    </div>
    <div class="item">
        <div class="item-hd">折叠面板标题</div>
        <div class="item-md">折叠面板内容</div>
    </div>
</div>
************************************/
$(function () {
    // 首次加载时，检查是否有 active 类的面板
    $(".collapse-loop .item.active").each(function () {
        $(this).children(".item-md").show();  // 确保初始化时显示 active 面板内容
    });

    // 折叠面板
    $(".collapse-loop").on("click", ".item-hd", function () {
        console.log(`折叠面板`,$(this))
        $(this).siblings(".item-md").slideToggle().parents(".item").toggleClass("active").siblings(".item").removeClass("active").children(".item-md").slideUp();
    });

    //关闭其中的关闭按钮时，本按钮关闭
    $(".collapse-loop").on("click", ".close", function () {
        $(this).parents(".item-md").slideUp().parents(".item").removeClass("active");
    })
});